import { Divider } from '@fluentui/react-components';
import { ReactNode } from 'react';

import './page.scss';

export interface PageProps {
	title: string;
	actions?: React.ReactNode;
	children: ReactNode | undefined;
}

export default function Page(props: PageProps) {
	return (
		<>
			<div className={'root'}>
				<div className={'pagebar'}>
					<span
						style={{ paddingLeft: '25px', paddingBottom: '25px' }}
						className='page-title pixel-font text-lg'
					>
						{props.title}
					</span>

					<div className={'actions'}>{props.actions}</div>
				</div>

				<Divider />
			</div>

			{props.children}
		</>
	);
}
